import { getBaseTypes as requestSetsGetters } from '@/js/plugins/store/helper/requestSet/getters'
// console.log(requestSetsGetters())
export default {
  ...requestSetsGetters(),
  // App Config
  APP_CONFIG: 'APP_CONFIG',
  APP_CONFIG_LINK_BY_TYPE: 'APP_CONFIG_LINK_BY_TYPE',
  APP_CONSENT_NECESSARY: 'APP_CONSENT_NECESSARY',
  DASHBOARD_URL: 'DASHBOARD_URL',
  SHOPMODUS: 'APP_SHOPMODUS',
  LOGOUT_URL: 'LOGOUT_URL',
  BASE_URL: 'BASE_URL',
  LOCALE_BASE_URL: 'LOCALE_BASE_URL',
  TERMS_URL: 'TERMS_URL',
  LANGUAGES: 'LANGUAGES',
  RETURN_API_URL: 'RETURN_API_URL',
  TESTIVAL_API_URL: 'TESTIVAL_API_URL',
  MESSAGE_STATUS_URL: 'MESSAGE_STATUS_URL',
  MESSAGE_UPDATE_URL: 'MESSAGE_UPDATE_URL',
  MESSAGE_LIST_URL: 'MESSAGE_LIST_URL',
  MESSAGE_DETAIL_URL: 'MESSAGE_DETAIL_URL',
  MESSAGE_ATTACHMENT_URL: 'MESSAGE_ATTACHMENT_URL',
  BU_NEWS_BASE_URL: 'BU_NEWS_BASE_URL',
  BLOCKINGREASON_URL: 'BLOCKINGREASON_URL',
  SNIP_URL: 'SNIP_URL',
  SHOPMODE_LOGOUT_URL: 'SHOPMODE_LOGOUT_URL',
  CLIENT_DATA_URL: 'CLIENT_DATA_URL',
  SPARE_PARTS_GROUPS: 'SPARE_PARTS_GROUPS',
  SEARCH_DETAIL_LINK: 'SEARCH_DETAIL_LINK',
  CATALOG: 'CATALOG',
  COMPANY_SEPA_MANDATES: 'COMPANY_SEPA_MANDATES',
  CUSTOMER_EMAIL: 'CUSTOMER_EMAIL',
  // CATALOG_TREE: 'CATALOG_TREE',
  // CATALOG_LIST: 'CATALOG_LIST',
  AVAILABILITY_WATCH_URL: 'AVAILABILITY_WATCH_URL',
  SCOPE: 'SCOPE',
  AVAILABLE_SCOPES: 'AVAILABLE_SCOPES',
  ALL_ATTRIBUTE_CODE_TO_ID_MAP: 'ALL_ATTRIBUTE_CODE_TO_ID_MAP',
  ENGINE_COMPLAINT_FORM_URL: 'ENGINE_COMPLAINT_FORM_URL',
  ENGINE_COMPLAINT_FORM_TITLE: 'ENGINE_COMPLAINT_FORM_TITLE',
  ENGINE_COMPLAINT_WORKTIME_FORM_URL: 'ENGINE_COMPLAINT_WORKTIME_FORM_URL',
  BATTERY_CHARGER_COMPLAINT_FORM_URL: 'BATTERY_CHARGER_COMPLAINT_FORM_URL',
  SERVICE_WARRANTY_PAGE_URL: 'SERVICE_WARRANTY_PAGE_URL',
  PAY_NOW_TICKET_URL: 'PAY_NOW_TICKET_URL',
  BACKORDER_PAGE_URL: 'BACKORDER_PAGE_URL',

  // Portal Targets
  PORTAL_TARGETS: 'PORTAL_TARGETS',

  // Overlay
  OVERLAY_VISIBILITY: 'OVERLAY_VISIBILITY',

  // Basket
  BASKET_VISIBILITY: 'BASKET_VISIBILITY',

  // Navigation
  NAVIGATION_DRAWER_VISIBILITY: 'NAVIGATION_DRAWER_VISIBILITY',

  // Search
  // SEARCH_DIALOG_VISIBILITY: 'SEARCH_DIALOG_VISIBILITY',
  // SEARCH_QUERY: 'SEARCH_QUERY',
  // SEARCH_PAGE: 'SEARCH_PAGE',
  // SEARCH_LIMIT: 'SEARCH_LIMIT',
  // SEARCH_URL: 'SEARCH_URL',
  // SEARCH_QUERY_MIN_LENGTH: 'SEARCH_QUERY_MIN_LENGTH',
  SEARCH_IMMEDIATE: 'SEARCH_IMMEDIATE',
  // SEARCH_IS_OVERVIEW: 'SEARCH_IS_OVERVIEW',
  // SEARCH_PARAMS: 'SEARCH_PARAMS',
  // SEARCH_PARAMS_BY_TYPE: 'SEARCH_PARAMS_BY_TYPE',

  // Product List
  PRODUCT_VIEW: 'PRODUCT_VIEW',
  IS_PRODUCT_LIST_VIEW: 'IS_PRODUCT_LIST_VIEW',
  IS_PRODUCT_GRID_VIEW: 'IS_PRODUCT_GRID_VIEW',

  SELECTED_BRAND: 'SELECTED_BRAND',
  // SparePartsTree
  SPAREPARTS_DETAIL_URL: 'SPAREPARTS_DETAIL_URL',

  // Dimension
  GET_DIMENSIONS: 'GET_DIMENSIONS',
  GET_WIDTH: 'GET_WIDTH',
  GET_HEIGHT: 'GET_HEIGHT',
  IS_XS_WIDTH: 'IS_XS_WIDTH',
  IS_SM_WIDTH: 'IS_SM_WIDTH',
  IS_LG_WIDTH: 'IS_LG_WIDTH',
  IS_XL_WIDTH: 'IS_XL_WIDTH',

  // Language
  LOCALE: 'LOCALE',

  // User
  USER: 'USER',
  USERNAME: 'USERNAME',
  CUSTOMER_NUMBER: 'CUSTOMER_NUMBER',
  SUBUSER: 'SUBUSER',
  IS_SUBUSER: 'IS_SUBUSER',
  IS_GUEST_SUBUSER: 'IS_GUEST_SUBUSER',
  SUPPORT_USER: 'SUPPORT_USER',
  SITE_ATTRIBUTES: 'SITE_ATTRIBUTES',
  USER_BRANDS: 'USER_BRANDS',
  USER_COMPANIES: 'USER_COMPANIES',
  USER_CLIENTS: 'USER_CLIENTS',
  USER_GROUPS: 'USER_GROUPS',
  HAS_ROLE: 'HAS_ROLE',
  ROLEIDS_TO_ROLEKEYS: 'ROLEIDS_TO_ROLEKEYS',
  GET_ROLEKEYS: 'GET_ROLEKEYS',
  HAS_SPAREPARTS_GROUP: 'HAS_SPAREPARTS_GROUP',
  USER_CURRENCY: 'USER_CURRENCY',
  HIDE_SPAREPARTS_FROM_USER_COMPANY: 'HIDE_SPAREPARTS_FROM_USER_COMPANY',
  CUSTOMER_COUNTRYID: 'CUSTOMER_COUNTRYID',
  CUSTOMER_LANGUAGEID: 'CUSTOMER_LANGUAGEID',
  CUSTOMER_FIRSTNAME: 'CUSTOMER_FIRSTNAME',
  CUSTOMER_LASTNAME: 'CUSTOMER_LASTNAME',
  CUSTOMER_TELEPHONE: 'CUSTOMER_TELEPHONE',
  USER_CAN_ISSUE_SEPA_MANDATES: 'USER_CAN_ISSUE_SEPA_MANDATES',
  EVENT_COUNT: 'EVENT_COUNT',

  // Filter
  FILTER: 'FILTER',
  FILTER_CATALOG: 'FILTER_CATALOG',
  FILTER_CATALOG_TREE: 'FILTER_CATALOG_TREE',
  ALL_FILTER: 'ALL_FILTER',
  FILTER_SEARCH_TYPE_REVERSE: 'FILTER_SEARCH_TYPE_REVERSE',
  FILTER_CONFIG_DATA: 'FILTER_CONFIG_DATA',
  FILTER_TYPES: 'FILTER_TYPES',
  FILTER_TYPES_GROUPED: 'FILTER_TYPES_GROUPED',
  FILTER_BY_TYPE: 'FILTER_BY_TYPE',
  FILTER_EBIKE_ENGINE_MODEL: 'FILTER_EBIKE_ENGINE_MODEL',
  FILTER_ITEM_BRAND: 'FILTER_ITEM_BRAND',
  FILTER_ITEM_COLOR: 'FILTER_ITEM_COLOR',
  FILTER_ITEM_FILTER_COLOR: 'FILTER_ITEM_FILTER_COLOR',
  FILTER_ITEM_FRAME_SIZE_CM: 'FILTER_ITEM_FRAME_SIZE_CM',
  FILTER_ITEM_FRAME_SIZE_CODE: 'FILTER_ITEM_FRAME_SIZE_CODE',
  FILTER_ITEM_GENDER_FRAME: 'FILTER_ITEM_GENDER_FRAME',
  FILTER_ITEM_WHEEL_SIZE_INCH: 'FILTER_ITEM_WHEEL_SIZE_INCH',
  FILTER_PRODUCT_E_BIKE: 'FILTER_PRODUCT_E_BIKE',
  FILTER_PRODUCT_SEGMENT: 'FILTER_PRODUCT_SEGMENT',
  // ACTIVE_FILTERS_SETTINGS_BY_SCOPE: 'ACTIVE_FILTERS_SETTINGS_BY_SCOPE',
  SCOPE_HAS_ACTIVE_FILTERS: 'SCOPE_HAS_ACTIVE_FILTERS',

  // Notification Badge
  NOTIFICATION_MESSAGE: 'NOTIFICATION_MESSAGE',
  NOTIFICATION_MESSAGE_OPEN: 'NOTIFICATION_MESSAGE_OPEN',
  NOTIFICATION_MESSAGE_TYPE: 'NOTIFICATION_MESSAGE_TYPE',

  // LaunchPortal
  LAUNCH_PORTAL: 'launchPortal',

  // news
  NEWS_UNREAD: 'NEWS_UNREAD',

  // MESSAGING
  MESSAGING_DOMAIN: 'MESSAGING_DOMAIN',
  MESSAGING_WS_PORT: 'MESSAGING_WS_PORT',
  // MESSAGING_TOKEN: 'MESSAGING_TOKEN',
  HUBSPOT_MIDDLEWARE_FORM_API: 'HUBSPOT_MIDDLEWARE_FORM_API',
  HUBSPOT_MIDDLEWARE_VISITOR_IDENTIFICATION_API: 'HUBSPOT_MIDDLEWARE_VISITOR_IDENTIFICATION_API',

  CURRENT_LANG_CODE: 'CURRENT_LANG_CODE',

  // ZENLOOP
  ZENLOOP_SURVEYS: 'ZENLOOP_SURVEYS',

  PAYMENT_TERMS_URL: 'PAYMENT_TERMS_URL',
  SDGP_API_URL: 'SDGP_API_URL',
  USERMANAGEMENT_URL: 'USERMANAGEMENT_URL',
  MULEAPISERVICE_URL: 'MULEAPISERVICE_URL',
  RMA_OVERVIEW_PAGE_URL: 'RMA_OVERVIEW_PAGE_URL',
  CONNECTED_BIKE_MANUAL_URL: 'CONNECTED_BIKE_MANUAL_URL',
  ADMIN_URL: 'ADMIN_URL',
  ENVIRONMENT: 'ENVIRONMENT',
  ENVIRONMENT_TYPO3: 'ENVIRONMENT_TYPO3',
}
